import React, { useContext, useState } from 'react';
import {
  BodyControls,
  BodyDesc,
  BodyBlockBody,
  FormGroup,
  FormGroupLabel,
  BodyBlock,
  BodyBlockDesc,
  ButtonCancel,
  ButtonSubmit, MFASecretCode, MFAImage
} from '../styles';
import { TStep } from '../index';
import { TError } from 'models';
import { AccountContext } from 'src/components/Accounts';
import renderErrors from '../common/Errors';
import Input from '../components/Input';
import { translate } from '../../../utils';
import BlockHead from '../common/BlockHead';
import { isMFAValid, onChangeMFAInput, TMFAForm } from '../../../utils/MFAHelpers';

interface Props {
  onChangeStep: (step: TStep) => void,
}

export const BodyMFASetup = ({ onChangeStep }: Props) => {

  const { enableMfa, challengeData } = useContext(AccountContext);

  const [form, updateForm] = useState<TMFAForm>({
    code: '',
    errorApi: [],
  });

  const onSubmit = (event: React.FormEvent) => {
    if (event) {
      event.preventDefault();
    }

    const { code, errorApi } = form;

    if (errorApi.length > 0) {
      updateForm({
        ...form,
        errorApi: [],
      });
    }

    if (isMFAValid(code)) {
      enableMfa(code, onAPIError);
    } else {
      updateForm({
        ...form,
        errorApi: [{ code: '', message: translate({ key: 'sso.mfa.error.code_not_valid' }) }],
      });
    }
  };

  const onAPIError = (err: TError[]) => {
    if (err?.length) {
      onChangeMFAInput('errorApi', err, form, updateForm);
    }
  };

  const renderForm = () => (
    <>
      <BodyBlockDesc>
        <BlockHead title={translate({ key: 'sso.mfa.setup.title' })} />
        <BodyDesc dangerouslySetInnerHTML={{ __html: translate({ key: 'sso.mfa.setup.desc1' }) }} />
        <MFAImage src={challengeData?.challenge_parameters?.qr_code} alt="QR Code" />
        <BodyDesc dangerouslySetInnerHTML={{ __html: translate({ key: 'sso.mfa.setup.desc2' }) }} />
        <MFASecretCode>{challengeData?.challenge_parameters?.secret_code}</MFASecretCode>
        <BodyDesc dangerouslySetInnerHTML={{ __html: translate({ key: 'sso.mfa.setup.desc3' }) }} />
      </BodyBlockDesc>
      <BodyBlockBody onSubmit={onSubmit}>
        {form.errorApi?.length ? renderErrors(form.errorApi) : null}
        <FormGroup>
          <FormGroupLabel htmlFor="code">{translate({ key: 'sso.mfa.setup.input' })}</FormGroupLabel>
          <Input
            name="code"
            id="code"
            value={form.code}
            autoComplete="one-time-code"
            minLength={6}
            required={true}
            handleChange={(value) => onChangeMFAInput('code', value, form, updateForm)}
          />
        </FormGroup>
        <BodyControls>
          <ButtonSubmit size="l" type="submit">
            {translate({ key: 'sso.buttons.mfa.set' })}
          </ButtonSubmit>
          <ButtonCancel size="l" type="reset" onClick={() => onChangeStep('login')}>
            {translate({ key: 'sso.buttons.cancel' })}
          </ButtonCancel>
        </BodyControls>
      </BodyBlockBody>
    </>
  );

  return (
    <BodyBlock>
      {renderForm()}
    </BodyBlock>
  );

};
